var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-active-status",on:{"click":function($event){return _vm.change()}}},[_c('i',{staticClass:"fa",class:_vm.status})])
}
var staticRenderFns = []

export { render, staticRenderFns }